/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
import {Code} from '../../../../components/utils/code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Install client"
    }), "\n", _jsxs(_components.p, {
      children: ["WebSemaphore may be operated via both Rest and Websockets apis directly. For convenience, we provide client libraries.\nThe ts/js library is available immediately.\nIf you need support for other languages/stacks please ", _jsx("a", {
        href: "/contact",
        children: "contact us"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "TypeScript/JavaScript"
    }), "\n", _jsx(_components.p, {
      children: "Install using"
    }), "\n", _jsx(Code, {
      height: "50px",
      value: "npm i --save websemaphore",
      language: "shell"
    }), "\n", _jsx(_components.p, {
      children: "This should get you started. Please check the next sections for rest and websockets usage."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
